import type { TOC } from '@ember/component/template-only';
import NavigationHeader from 'frontend-payments/components/navigation/header';
import type AuthenticatedController from 'frontend-payments/controllers/authenticated';
import onWindow from 'frontend-payments/modifiers/on-window';

interface AuthenticatedSignature {
  Args: {
    controller: AuthenticatedController;
  };
}

<template>
  <div {{onWindow "focus" @controller.refreshRoute}}>
    <NavigationHeader
      @isAccountSelectorDisabled={{@controller.isLoadingAccountData}}
    />

    {{outlet}}
  </div>
</template> satisfies TOC<AuthenticatedSignature>;
